import * as Widgets from "./widgets"
import * as Reports_ from './searchdirectory-reports/app'

export const widgets = Widgets
export const Reports = Reports_


// WEBPACK FOOTER //
// ./src/searchdirectory/searchdirectory.ts